import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

const FJTextBasedEditingConfig = {
    currentMenuName: 'ai-text-based-editing',
    unitPrice: 0.2, // 0.2 积分每分钟
    freeLimitType: 'audio-to-word',
    highLightUnitPrice: 1, // 高光剪辑每次1积分
    freeLimitHighlightType: 'highlight-wditing',
    originalImageKey: 'ai/input/text-based-editing/',
    // notImageBoxBgUrl:
    //     environment === LOCAL
    //         ? `/public/img/textBasedEdit/bg.png?v=${FJVersionConfig.staticPathVersion}`
    //         : `/app/ai-tools/img/textBasedEdit/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/textBasedEdit/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/textBasedEdit/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
};

export default FJTextBasedEditingConfig;
